import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import flueidLogoRegistered from "css/images/logos/FlueidPro_R_logo.png";
import { Link, useHistory } from "react-router-dom";
import { ContactSection } from "../contactSection";
import { Button } from "../button";
import { DividerVertical } from "../dividerVertical";
import { ContactTopic } from "../contactForm/types";
import { stringifyParams } from "utilities/apiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { ButtonIcon } from "../buttonIcon";
import { ReactComponent as FlueidLogoMark } from "css/images/svg/logos/logomark-flueidpro.svg";
import { ReactComponent as HamburgerIcon } from "./assets/icon_Hamburger_Menu.svg";

export function HomeNavbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const history = useHistory();

  const openMobileMenu = () => {
    document.body.style.overflow = "hidden"; // Prevent scrolling when menu is open
    setMobileMenuOpen(true);
  };

  const closeMobileMenu = () => {
    document.body.style.overflow = ""; // Restore scrolling when menu is closed
    setMobileMenuOpen(false);
  };

  const [contactFormOpen, setContactFormOpen] = useState(false);

  const openContactForm = (topic?: ContactTopic) => {
    if (topic) {
      history.replace(location.pathname + stringifyParams({ topic }));
    }

    setContactFormOpen(true);
  };

  const closeContactForm = () => {
    setContactFormOpen(false);
  };

  useEffect(() => {
    if (!mobileMenuOpen && contactFormOpen) {
      closeContactForm();
    }
  }, [mobileMenuOpen, contactFormOpen]);

  return (
    <>
      <nav className={styles.root}>
        <div className={styles.logo_wrapper}>
          <Link to="/" className={styles.logo}>
            <img src={flueidLogoRegistered} width={147}></img>
          </Link>
        </div>
        <div className={styles.links}>
          <Link to="/contact" className={styles.contact_link}>
            <Button className={styles.contact_button}>Contact</Button>
          </Link>
          <DividerVertical className={styles.divider} />
          <Link to="/auth/sign-in">
            <Button primary radius="sm" className={styles.sign_in_button}>
              Sign In
            </Button>
          </Link>
          <button className={styles.menu_bars} onClick={openMobileMenu}>
            <HamburgerIcon />
          </button>
        </div>
      </nav>
      <nav className={styles.mobile_nav} data-open={mobileMenuOpen}>
        <header className={styles.mobile_nav_header}>
          <FlueidLogoMark width={20} />
          <ButtonIcon onClick={closeMobileMenu}>
            <FontAwesomeIcon icon={faXmark} fontSize={20} color="black" />
          </ButtonIcon>
        </header>
        <div className={styles.nav_scroll_area}>
          {contactFormOpen ? (
            <ContactSection className={styles.contact_section} />
          ) : (
            <ul className={styles.mobile_links}>
              <li className={styles.mobile_link} onClick={() => openContactForm(ContactTopic.Demo)}>
                Schedule a Demo
              </li>
              <li className={styles.mobile_link} onClick={() => openContactForm()}>
                Contact Us
              </li>
              <li className={styles.mobile_link}>
                <Link to="/auth/sign-in">
                  <Button primary radius="sm" className={styles.auth_button}>
                    Sign In
                  </Button>
                </Link>
              </li>
            </ul>
          )}
        </div>
      </nav>
    </>
  );
}
